module.exports = __webpack_public_path__ + "static/media/ReviewCX.d68e4bed.jpg";